import { createSelector } from 'reselect';

import { createGenericSelector } from '../GenericFetch/selectors';
import { NAMESPACE } from './constants';

const getKey = props => props.slug;

export const selectLiveFeed = createGenericSelector(NAMESPACE, 'data', getKey);
export const selectError = createGenericSelector(NAMESPACE, 'error', getKey);
export const selectLoading = createGenericSelector(
  NAMESPACE,
  'fetching',
  getKey,
);

const selectLastVisit = (state, props) =>
  state.liveFeed.live_feed_visit[props.slug];

export const selectLiveFeedQuestions = createSelector(
  selectLiveFeed,
  (feeds = []) => feeds.filter(feed => feed.type === 'q'),
);

export const selectLiveFeedInfo = createSelector(selectLiveFeed, (feeds = []) =>
  feeds.filter(feed => feed.type === 'i' || feed.content_type === 'interview'),
);

export const selectCountUnread = createSelector(
  selectLiveFeed,
  selectLastVisit,
  (feeds = [], last_visit) => {
    const time = last_visit ? new Date(last_visit).getTime() : null;

    return feeds.filter(
      f => last_visit == null || new Date(f.created).getTime() > time,
    ).length;
  },
);
